module.exports = __webpack_public_path__ + "img/2.fc7848b7.jpg";